import { carouselData } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            重磅推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队精心甄选的必读漫画，每一部都不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className="group block bg-background-100 rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer no-underline"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-[11px] font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-primary-600 font-medium mb-2">
                  {item.subtitle}
                </p>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}